const base = window._env_.VUE_APP_HOST

function defaultParams (params) {
  return {
    ...params
  }
}

function defaultConfig (config) {
  return {
    ...config,
    params: defaultParams(config.params),
  }
}

export const getAccessKeys = params => {
  return http.get(`${base}/access-keys`, defaultConfig({ params }))
}

export const disableAccessKey = id => {
  return http.put(`${base}/access-keys/${id}`, { status: 0 })
}
export const deleteAccessKey = id => {
  return http.delete(`${base}/access-keys/${id}`)
}

export const enableAccessKey = id => {
  return http.put(`${base}/access-keys/${id}`, { status: 1 })
}

export const createAccessKey = params => {
  return http.post(`${base}/access-keys`, params)
}
